import { Box, IconButton, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import Scan from './Scan';

interface Props {
  scanIds: string[];
}

function Scans({ scanIds: scans }: Props) {
  const [expanded, setExpanded] = useState(true);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          height: '62px',
          backgroundColor: '#f5f7fd',
          border: '1px solid #E6E7E9',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Typography
          variant="h6"
          sx={(theme) => ({ marginLeft: theme.spacing(3) })}>
          Scans
        </Typography>
        <Box>
          <IconButton
            aria-label="logout"
            onClick={() => setExpanded((prev) => !prev)}
            size="large"
            sx={(theme) => ({ marginRight: theme.spacing(1) })}>
            {expanded && <ExpandLessIcon />}
            {!expanded && <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>
      {expanded &&
        scans?.length > 0 &&
        scans.map((a) => <Scan key={a} id={a} />)}
      {expanded && scans?.length === 0 && (
        <Typography
          variant="body1"
          color={(theme) => theme.palette.text.disabled}
          sx={(theme) => ({ padding: theme.spacing(3) })}>
          No scans for this migration.
        </Typography>
      )}
    </>
  );
}

export default Scans;
